import { render, staticRenderFns } from "./ListDDPage.vue?vue&type=template&id=79ec9362&"
import script from "./ListDDPage.vue?vue&type=script&lang=js&"
export * from "./ListDDPage.vue?vue&type=script&lang=js&"
import style0 from "./ListDDPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports